import Guid from "_shared/guids/guid";
import SystemNotification from "notifications/system-notifications/system-notification";
import {
  parseSystemMessageSeverity,
  SystemMessageSeverity,
} from "notifications/system-notifications/system-message-severity";

export default class SystemNotificationAPIResponse {
  public id?: string;
  public content?: string;
  public message?: string;
  public severity?: SystemMessageSeverity;
  public createdDate?: string;

  public constructor(values: Partial<SystemNotificationAPIResponse>) {
    this.id = values.id;
    this.content = values.content;
    this.message = values.message;
    this.severity = parseSystemMessageSeverity(values.severity);
    this.createdDate = values.createdDate;
  }

  public deserialize(): SystemNotification {
    if (!this.id) {
      throw new Error('SystemNotificationAPIResponse.deserialize(): id is required');
    }
    if (!this.content && !this.message) {
      throw new Error('SystemNotificationAPIResponse.deserialize(): message or content is required');
    }
    return new SystemNotification(new Guid(this.id), this.message ?? this.content!, this.severity, this.createdDate);
  }
}
